import React from "react";
import PropTypes from "prop-types";

// load the helpers so we can use the formatPrice function below
import {formatPrice} from "../helpers"

class Fish extends React.Component {
    // this is static because it is the same for all fish
    static propTypes = {
        // the shape PropType is used fro objects
        details: PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string,
            price: PropTypes.number,
            desc: PropTypes.string,
            status: PropTypes.string
        }),
        addToOrder: PropTypes.func
    };

    handleClick = () => {
        this.props.addToOrder(this.props.index);
    };

    render() {
        // const image = this.props.details.image;
        // const name = this.props.details.name;
        // instead of above can use ES6 destructuring below to set multiple at one time
        // remember details got here as a prop on Fish during the loop in App
        // this:  { Object.keys(this.state.fishes).map(key => <Fish key={key} details={this.state.fishes[key]}/>) }
        const {image, name, price, desc, status} = this.props.details;

        // set a boolean variable equal to true if available
        // if status = available then isAvailable = true
        // this gets used below is disabled={!isAvalailable} which CSS get applied to
        const isAvalailable = status === "available";

        return (
            <li className="menu-fish">
                <img src={image} alt={name}/>
                <h3 className="fish-name">
                    {name}
                    <span className="price">{formatPrice(price)}</span>
                </h3>
                <p>{desc}</p>
                <button disabled={!isAvalailable} onClick={this.handleClick}>
                    {isAvalailable ? "Add To Order" : "Sold Out"}
                </button>
            </li>
        )
    }
}

export default Fish;

// NOTES:
// a ternary operator is a way to do shorthand if statement as uses here:
// {isAvalailable ? "Add To Order" : "Sold Out"}
//
// and alternate way to so this: <button disabled={!isAvalailable} onClick={this.handleClick}>
// is inline function:  <button disabled={!isAvalailable} onClick={()=>this.props.addToOrder(this.props.index)}>
// the  ()=>this.props.addToOrder(this.props.index)  is an inline function
// rule of thumb is if you are only using the function in one place, do it that way.
// but I left it as is




// WEBPACK FOOTER //
// ./src/components/Fish.js